import { ApiResult, HttpClient } from "../http.js";
import { PendingMembershipDto } from "../types/companies.js";
import { UserOrganizationDto } from "../types/users.js";

/**
 * `/api/users/me/*` bootstrap endpoints that only depend on the caller's
 * identity, not an already-selected active organization.
 */
export class MeApi {
  constructor(private readonly http: HttpClient) {}

  organizations(): Promise<ApiResult<UserOrganizationDto[]>> {
    return this.http.get<UserOrganizationDto[]>("/api/users/me/organizations");
  }

  /** Companies the caller is offered but cannot use until their email is confirmed. */
  pendingMemberships(): Promise<ApiResult<PendingMembershipDto[]>> {
    return this.http.get<PendingMembershipDto[]>("/api/users/me/pending-memberships");
  }

  /**
   * "Jeg har bekræftet": activates what the caller's confirmed email now allows and returns the
   * companies that are still pending.
   */
  activatePendingMemberships(): Promise<ApiResult<PendingMembershipDto[]>> {
    return this.http.post<PendingMembershipDto[]>("/api/users/me/pending-memberships/activate");
  }
}
